import React, {useCallback, useState} from "react";
import BuyItNowAPICLIENT from "../../../modules/BuyItNowAPIClient";
import PropTypes from "prop-types";
import ValidationCheckmark from "./ValidationCheckmark";

const EmailField = ({updateValidatedEmail}) => {
  const [
    email,
    setEmail
  ] = useState("");

  const [
    result,
    setResult
  ] = useState("");

  const [
    validated,
    setValidated
  ] = useState(false);

  const handleEmailChange = useCallback((event) => {
    setEmail(event.target.value);
    setResult("");
  }, [
    email,
    result
  ]);

  const setFailureMessage = () => {
    setResult("Error in the request");
  };

  const setSuccessMessage = (response) => {
    if (response.success) {
      setValidated(true);
      updateValidatedEmail(response.email);
    } else {
      setValidated(false);
      updateValidatedEmail("");
      setResult(response.errors.email);
    }
  };

  const triggerEmailValidation = useCallback(() => {
    BuyItNowAPICLIENT.validateEmail(email, setSuccessMessage, setFailureMessage);
  }, [
    email,
    setSuccessMessage,
    setFailureMessage
  ]);

  return (
    <label className="email">
      Email*
      <br />
      <input
        className="email-field"
        id="emailAddress"
        name="emailAddress"
        onBlur={triggerEmailValidation}
        onChange={handleEmailChange}
        onSubmit={triggerEmailValidation}
        type="text"
        value={email}
      />
      {validated && <ValidationCheckmark />}
      <div className="email-validation">
        {result}
      </div>
    </label>
  );
};

EmailField.propTypes = {"updateValidatedEmail": PropTypes.func.isRequired};

export default EmailField;
